var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 7.541a.49.49 0 01-.348-.144L.144.84a.495.495 0 01.7-.7L7.4 6.7a.492.492 0 01-.348.84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.492 4.917A.492.492 0 010 4.425V.491a.492.492 0 01.492-.492h3.934a.492.492 0 010 .984H.983v3.442a.492.492 0 01-.491.492zM12.951 7.541a.492.492 0 01-.348-.84L19.16.144a.495.495 0 01.7.7L13.299 7.4a.49.49 0 01-.348.141z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.508 4.917a.492.492 0 01-.492-.492V.983h-3.443a.492.492 0 110-.984h3.934a.492.492 0 01.492.492v3.934a.492.492 0 01-.491.492zM19.508 20a.49.49 0 01-.348-.144l-6.557-6.557a.495.495 0 01.7-.7l6.556 6.56a.492.492 0 01-.348.84z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.508 20h-3.934a.492.492 0 110-.984h3.443v-3.442a.492.492 0 11.984 0v3.934a.492.492 0 01-.493.492z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.492 20a.492.492 0 01-.348-.84l6.558-6.557a.495.495 0 01.7.7L.84 19.859A.49.49 0 01.492 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.426 20H.492A.492.492 0 010 19.508v-3.934a.492.492 0 01.984 0v3.442h3.443a.492.492 0 110 .984z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.2bf6c7419bda410438e386866a84428c.svg";
export { ForwardRef as ReactComponent };